import { IBaseAction } from "../Actions/BaseAction";

export type SetSideNavOpenAction = IBaseAction<boolean>;

export type SideNavActionType = SetSideNavOpenAction;

export const SET_SIDE_NAV_OPEN = "SET_SIDE_NAV_OPEN";
